import { JwtPayload } from 'jwt-decode';
import { AssumedIdentityData } from 'swo-ciam-common-react';

import { Claims } from './claims.enum';

export type QuickLink = {
  id: string;
  url: string;
  displayName: string;
  name?: string;
  icon?: string;
  contextType?: string;
  description?: string;
  linkType?: string;
  isStatic?: boolean;
};

export type SCU = {
  azureCloud: {
    secretName: string;
    subscriptionId: string;
  }[];
  customerName: string;
  customerSCU: string;
  keyVault: {
    baseUrl: string;
  };
  mailAddress: string;
  pycTenantId: string;
};

export type CIAMPermission = {
  id: string;
  name: string;
};

export enum CIAMSystemRoles {
  TenantAdmin = 'TENANT_ADMIN',
  PlatformAdmin = 'PLATFORM_ADMIN',
  PortalAdmin = 'PORTAL_ADMIN',
}

export type CIAMRole = {
  id: string;
  name: string;
  type: 'system' | 'custom' | 'service';
};

export type CiamTenant = {
  id?: string;
  name?: string;
  scu?: string;
};

export type DecodedToken = JwtPayload & {
  // detailing our custom claims here
  [Claims.SCU]: Array<SCU>;
  'http://claims.pyracloud.com/tenantId': string;
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress': string;
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name': string;

  scope: string;
  // eslint-disable-next-line camelcase
  ciam_permissions: Array<CIAMPermission> | Array<string>;
  // eslint-disable-next-line camelcase
  ciam_roles: Array<CIAMRole> | Array<string>;
  // eslint-disable-next-line camelcase
  ciam_user: boolean;
  // eslint-disable-next-line camelcase
  ciam_tenants?: CiamTenant[];
  // eslint-disable-next-line camelcase
  ciam_emulated_user: AssumedIdentityData;
  // eslint-disable-next-line camelcase
  ciam_emulated_permissions?: Array<CIAMPermission> | Array<string>;
  // eslint-disable-next-line camelcase
  ciam_emulated_roles?: Array<CIAMRole> | Array<string>;
  // eslint-disable-next-line camelcase
  ciam_emulated_tenants?: CiamTenant[];
  // eslint-disable-next-line camelcase
  ciam_user_quick_links?: QuickLink[];
};
